module.exports = __webpack_public_path__ + "media/images/countryrect/sx-4c78a5f6c7bfb80413b40b4085bdc391.svg";